// packages/shared/api-client/endpoints/images.js
// Image upload API endpoints

import { baseApi } from "../baseApi";

/**
 * Image API endpoints
 * Provides presigned S3 URLs for uploading and downloading images (posts, profiles, etc.)
 */
const imageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get presigned URL for image upload
    getImageUploadUrl: builder.mutation({
      query: ({ fileName, fileType, fileSize, imageType }) => ({
        url: '/api/images/upload',
        method: 'POST',
        body: { fileName, fileType, fileSize, imageType }, // imageType: 'post' | 'profile'
      }),
    }),

    // Get presigned URL for image download (to view private S3 images)
    getImageDownloadUrl: builder.query({
      query: (imageUrl) => ({
        url: '/api/images/download-url',
        method: 'GET',
        params: { imageUrl },
      }),
    }),
  }),
});

// Export hooks for usage in components
export const useGetImageUploadUrlMutation = imageApi.useGetImageUploadUrlMutation;
export const useGetImageDownloadUrlQuery = imageApi.useGetImageDownloadUrlQuery;
export const useLazyGetImageDownloadUrlQuery = imageApi.useLazyGetImageDownloadUrlQuery;
